(function ($) {
    $(() => {
        const selector = '.bs-multiselect select, select.bs-multiselect';
        const defaultConfig = {
            templates: {
                button: '<button type="button" class="multiselect dropdown-toggle btn" data-bs-toggle="dropdown" aria-expanded="false"><span class="multiselect-selected-text"></span></button>',
            }
        };

        const onChangeMaxLimit = ($el, option, checked) => {
            const $selectedOptions = $el.find('option:selected');
            const limit = parseInt($el.attr('fr-multiselect-max'));

            if ($selectedOptions.length >= limit) {
                // Disable all other checkboxes.
                const $nonSelectedOptions = $el.find('option').filter((i, op) => {
					return !$(op).is(':selected');
                });
        
                $.each($nonSelectedOptions, (i, op) =>  { 
                    const $input = $el.closest('.ginput_container_multiselect').find('input[value="' + $(op).val() + '"]');
                    $input.prop('disabled', true);
                    $input.closest('.multiselect-option').css('pointer-events', 'none');
                });
            } else {
                // Enable all checkboxes.
                $el.find('option').each((i, op) =>  {
                    const $input = $el.closest('.ginput_container_multiselect').find('input[value="' + $(op).val() + '"]');
                    $input.prop('disabled', false);
                    $input.closest('.multiselect-option').css('pointer-events', '');
                });
            }
        }

        //Hack to go around the issue where Gravity Forms resets custom dropdowns on ajax validation
        $(window).on('fr:initialize-multiselect', () => {
            const $elems = $(selector).filter(':not(.fr--multiselect-initialized)');

            if($elems.length){
                $(window).on('fr:bsmultiselectjs-loaded', () => {
                    $.each($elems, (i, el) => { 
                        const configObj = JSON.parse($(el).attr('multiselect-config') || '{}');

                        $(el).multiselect({
                            ...defaultConfig, 
                            ...configObj,
                            ...{
                                onChange: function(option, checked, select) {
                                    const $el = $(el);
                                    $el.trigger('fr:multiselect-changed');

                                    if($el.is('[fr-multiselect-max]') && $el.attr('fr-multiselect-max').length){
                                        onChangeMaxLimit($el, option, checked);
                                    }
                                }
                            }
                        });
                        
                        const $btnGroup = $(el).parent().find('.btn-group');
                        const $dropdown = $btnGroup.find('.dropdown-menu');

                        if($btnGroup.length && $dropdown.length){
                            const $toggle = $btnGroup.find('.dropdown-toggle');
                            let currentPlacement = false;

                            const observer = new MutationObserver((mutationsList, observer) => {
                                mutationsList.forEach((mutation) => {
                                    if(mutation.type === 'attributes' && mutation.attributeName == 'data-popper-placement') {
                                        const placement = $dropdown.attr('data-popper-placement');

                                        if(currentPlacement == placement) return;

                                        currentPlacement = placement;

                                        $btnGroup.removeClass('top-start bottom-start');
                                        $toggle.removeClass('top-start bottom-start');

                                        if(placement !== undefined && placement !== false){
                                            $btnGroup.addClass(placement);
                                            $toggle.addClass(placement);
                                        }else{
                                            $btnGroup.removeClass('top-start bottom-start');
                                            $toggle.removeClass('top-start bottom-start');
                                        }
                                    }
                                });
                            });

                            const config = { attributes: true };
                            observer.observe($dropdown[0], config);
                        }
                    });
                    
                });
                $(window).trigger('fr:load-bsmultiselectjs');
                $elems.addClass('fr--multiselect-initialized');
            }
        });

        $(() => {
            $(window).trigger('fr:initialize-multiselect');
        });
    });
}( jQuery ));